import React, { useState, useEffect, useContext } from "react";
import { Tabs, Table } from "antd";
import { getScenarioStructure } from "../../services/api";
import { ActivityContext } from "../activity";
import _ from "lodash";

const { TabPane } = Tabs;

export default function DataTable() {
  const { filterData } = useContext(ActivityContext);

  const [TableColumn, setTableColumn] = useState([]);
  const [TableData, setTableData] = useState([]);
  const [Panes, setPanes] = useState([]);
  const [LoadingTable, setLoadingTable] = useState(false);

  useEffect(() => {
    ScenarioLists(
      filterData.scenarios.length != 0 ? filterData.scenarios[0].file : []
    );
    setPanes(
      filterData.scenarios.map((option) => ({
        name: option.name,
        value: option.file,
      }))
    );
  }, [filterData]);

  const ScenarioLists = async (file) => {
    setLoadingTable(true);
    const payload = {
      file,
      sheet: "1. FC",
    };
    const res = await getScenarioStructure(payload);

    if (res.status === 200) {
      const values = res.data.data.values;
      const result = dataFilter(values);

      setLoadingTable(false);
      setTableData(result);
      const columns = Object.keys(result[0])
        .reverse()
        .sort((a, b) => a - b);
      setTableColumn(
        columns.map((column) => ({
          title: column,
          dataIndex: column,
          key: column,
        }))
      );
    }
  };

  const tabClick = (file) => {
    ScenarioLists(file);
  };

  const dataFilter = (values) => {
    const { rangestart, rangeend, sectors, activities } = filterData;
    return values
      .map((item) => {
        const keys = Object.keys(item);
        const resultObj = {};
        keys.forEach((key) => {
          if (parseInt(key, 10)) {
            if (
              rangestart <= parseInt(key, 10) &&
              parseInt(key, 10) <= rangeend
            ) {
              resultObj[key] = item[key];
            }
          } else {
            resultObj[key] = item[key];
          }
        });
        return resultObj;
      })
      .filter(
        (item) =>
          sectors.includes(item.Sector) && activities.includes(item.Activity)
      );
  };

  if (filterData.scenarios.length === 0) {
    return "No data";
  }

  return (
    <Tabs tabPosition="left" onChange={(e) => tabClick(e)}>
      {Panes.map((pane) => (
        <TabPane tab={pane.name} key={pane.value}>
          <Table
            dataSource={TableData}
            columns={TableColumn}
            pagination={true}
            scroll={{ x: "auto" }}
            className="font-light"
            loading={LoadingTable}
          />
        </TabPane>
      ))}
    </Tabs>
  );
}
